<template>
  <section>
    <!--intro section-->
    <!--background image snippets-->
    <div
      v-rellax="{ speed: 10, center: true }"
      class="ticket-left position-absolute"
      style="z-index: -99;"
    >
      <img
        width="200px"
        src="../../assets/img/ticket-left.png"
        alt=""
        class=""
      />
    </div>
    <div
      v-rellax="{ speed: -1, center: true }"
      class="ticket-right position-absolute d-none d-md-block"
    >
      <img
        width="300px"
        src="../../assets/img/ticket-right.png"
        alt=""
        class=""
      />
    </div>

    <div class="container">
      <div class="row">
        <div class="col-10 offset-1 text-center col-lg-8 offset-lg-2">
          <h1
            class="page-title text-gradient pb-3"
            data-aos="fade-right"
            data-aos-easing="ease-in-out-quad"
            data-aos-once="true"
            data-aos-duration="1000"
          >
            {{ content.title }}
          </h1>
          <h4
            class="text-gradient pb-5 f-23 text-bold"
            data-aos="fade-right"
            data-aos-easing="ease-in-out-quad"
            data-aos-once="true"
            data-aos-delay="500"
            data-aos-duration="1000"
          >
            {{ content.subtitle }}
          </h4>
          <div
            class="d-flex justify-content-center my-5 animated bounce w-100 position-relative"
            style="z-index: 1;"
          >
            <span
              class="section-nav bg-white shadow-sm pointer"
              @click="scrollToSection('scroll-down')"
              data-aos="fade-down"
              data-aos-duration="3000"
              data-aos-easing="ease-in-out-back"
              data-aos-offset="-500"
              data-aos-once="true"
            >
              <img src="../../assets/svg/arrow-down.svg" alt="" class="" />
            </span>
            <!--<icon-layers id="scroll-down" class="fa-3x go-down mb-n5"-->
            <!--data-aos="fade-down"-->
            <!--data-aos-duration="3000"-->
            <!--data-aos-easing="ease-in-out-back"-->
            <!--data-aos-offset="-500"-->
            <!--data-aos-once="true"-->
            <!--data-aos-delay="1000">-->
            <!--<icon-vue icon="circle" class="text-white"/>-->
            <!--<a href="#scroll-down" class="text-lilac" target="_self">-->
            <!--<icon-vue icon="arrow-down" transform="shrink-10" class=""/>-->
            <!--</a>-->
            <!--</icon-layers>-->
          </div>
        </div>
      </div>
    </div>
    <!--END intro section-->

    <!--view content-->
    <div class="container">
      <!--hero images-->
      <div class="row mb-80 mt-n4" id="mt-n4">
        <div
          class="col-12 d-flex align-items-center justify-content-center flex-wrap"
        >
          <div
            class="img-ticket-flank-1 rounded-circle my-n2 position-relative d-none d-md-block"
            :style="{ background: `url(${images.smImg1})` }"
            data-aos="zoom-in-right"
            data-aos-offset="400"
            data-aos-easing="ease-in-out-back"
            data-aos-once="true"
            data-aos-delay="200"
            data-aos-duration="800"
          ></div>
          <div
            class="img-ticket-flank-2 rounded-circle my-n4 d-none d-md-block"
            :style="{ background: `url(${images.mainImg})` }"
            data-aos="zoom-out"
            data-aos-offset="400"
            data-aos-easing="ease-in-out-back"
            data-aos-once="true"
            data-aos-duration="500"
          ></div>
          <div
            class="img-ticket-flank-3 rounded-circle my-n4 d-none d-md-block"
            :style="{ background: `url(${images.smImg2})` }"
            data-aos="zoom-in-left"
            data-aos-offset="400"
            data-aos-easing="ease-in-out-back"
            data-aos-once="true"
            data-aos-delay="200"
            data-aos-duration="800"
          ></div>
        </div>
      </div>
      <!--END hero images-->

      <!-- Embed-->
      <div
        id="scroll-down"
        class="ticketlist-inline-checkout mt-100 mb-100"
        data-event="103935"
        data-params="step_bg_color=ffffff&step_line_color=c9bba1&step_circle_color=ff6a1d"
      ></div>

      <!-- End embed-->

      <!--<div id="scroll-down" class="mt-100">-->
      <!--<b-nav justified class="align-items-center d-flex">-->
      <!--<b-nav-item link-classes="d-lg-flex align-items-center" router-tag="div">-->
      <!--<icon-vue icon="check" class="mr-3 icon-size" :class="{'text-green': active > 1}"></icon-vue>-->
      <!--<div class="text-reduce">-->
      <!--<p class="font-weight-bold m-0 text-lg-left step-text text-uppercase">step 1</p>-->
      <!--<p class="font-weight-bold m-0 text-lg-left step-text text-uppercase">your tickets</p>-->
      <!--</div>-->
      <!--</b-nav-item>-->
      <!--<b-nav-item>-->
      <!--<b-dropdown-divider></b-dropdown-divider>-->
      <!--</b-nav-item>-->
      <!--<b-nav-item link-classes="d-lg-flex align-items-center" router-tag="div">-->
      <!--<icon-vue v-if="active >= 2" icon="check" class="mr-0 mr-md-3 icon-size"-->
      <!--:class="{'text-green': active > 2}"></icon-vue>-->
      <!--<icon-vue v-else :icon="['far','circle']" class="mr-0 mr-md-3 text-gray icon-size"-->
      <!--:class="{'text-green': active == 2}"></icon-vue>-->
      <!--<div class="text-reduce">-->
      <!--<p class="font-weight-bold m-0 text-lg-left step-text text-uppercase">step 2</p>-->
      <!--<p class="font-weight-bold m-0 text-lg-left step-text text-uppercase">payment method</p>-->
      <!--</div>-->
      <!--</b-nav-item>-->
      <!--<b-nav-item>-->
      <!--<b-dropdown-divider></b-dropdown-divider>-->
      <!--</b-nav-item>-->
      <!--<b-nav-item link-classes="d-lg-flex align-items-center" router-tag="div">-->
      <!--<icon-vue v-if="active == 3" icon="check" class="mr-0 mr-md-3 icon-size"-->
      <!--:class="{'text-green': active == 3}"></icon-vue>-->
      <!--<icon-vue v-else :icon="['far','circle']" class="text-gray mr-0 mr-md-3 icon-size"></icon-vue>-->
      <!--<div class="text-reduce">-->
      <!--<p class="font-weight-bold m-0 text-lg-left step-text text-uppercase">step 3</p>-->
      <!--<p class="font-weight-bold m-0 text-lg-left step-text text-uppercase">thank you</p>-->
      <!--</div>-->
      <!--</b-nav-item>-->
      <!--</b-nav>-->
      <!--</div>-->
      <!---->
      <!--<div class="row mt-26">-->
      <!--<div class="col-lg-8 bg-white border">-->
      <!--<div v-if="active === 1">-->
      <!--<div class="row border-bottom px-3 py-4">-->
      <!--<div class="col-12 d-flex align-items-center py-1">-->
      <!--<div class="mr-5">-->
      <!--<h1 class="m-0">03</h1>-->
      <!--<p class="m-0 mt-n2 text-uppercase text-nowrap">-->
      <!--<small>aug 19</small>-->
      <!--</p>-->
      <!--</div>-->
      <!--<div class="">-->
      <!--<h6 class="text-event m-0 text-uppercase font-weight-bold">-->
      <!--leicester carribean carnival</h6>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--&lt;!&ndash; tickets &ndash;&gt;-->
      <!--<div class="row border-bottom px-3 py-4 text-gr f-18"-->
      <!--v-for="(ticket, index) in ticketlistEvent.tickets"-->
      <!--:key="`ticket-${index}`">-->
      <!--<div class="col-12 py-2">-->
      <!--<div class="align-items-center text-gr row">-->
      <!--<div class="col-12 col-lg-7">-->
      <!--<p class="m-0 text-gr f-18">{{ticket.title}}</p>-->
      <!--</div>-->
      <!--<div class="mt-3 mt-lg-0 col-6 col-lg-3 text-right">-->
      <!--<app-ticket-input :val="numTickets(ticket.ticket_id)"-->
      <!--:max="parseInt(ticket.available) < 10 ? parseInt(ticket.available) : 10"-->
      <!--:min="0"-->
      <!--@changed="addRemoveTicket($event, ticket)">-->
      <!---->
      <!--</app-ticket-input>-->
      <!--</div>-->
      <!--<div class="mt-3 mt-lg-0 col-6 col-lg-2 text-right">-->
      <!--<p class="m-0">£{{ticket.price}}.00</p>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!---->
      <!--&lt;!&ndash;<div class="row border-bottom px-3 py-4 text-gr f-18">&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="col-12 py-2">&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="d-flex align-items-center justify-content-between row">&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="col-12 col-lg-7">&ndash;&gt;-->
      <!--&lt;!&ndash;<p class="m-0">Child Entry (5-13yrs)</p>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="mt-3 mt-lg-0 col-6 col-lg-3 text-right">&ndash;&gt;-->
      <!--&lt;!&ndash;<app-ticket-input :val="5" :min="0" :max="10"></app-ticket-input>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="mt-3 mt-lg-0 col-6 col-lg-2 text-right">&ndash;&gt;-->
      <!--&lt;!&ndash;<p class="m-0">£1.00</p>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!---->
      <!--</div>-->
      <!--<div v-if="active === 2" class="py-4 px-3">-->
      <!--&lt;!&ndash;<div class="row mb-30">&ndash;&gt;-->
      <!--&lt;!&ndash;<div class="col-12 ">&ndash;&gt;-->
      <!--&lt;!&ndash;<h6 class="m-0 heading">PAYMENT METHOD & PURCHASE</h6>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--<div class="row w-100 no-gutters">-->
      <!--<div class="col-12">-->
      <!--<b-form @submit.prevent="pay" ref="detail-form" autocomplete="off">-->
      <!--<div class="form-row m-0 w-100">-->
      <!--<div class="col-12 col-sm-6">-->
      <!--<b-form-group-->
      <!--id="grp-name"-->
      <!--label="Full Name"-->
      <!--label-for="input-name"-->
      <!--label-class="cust-label mb-0 text-uppercase"-->
      <!--&gt;-->
      <!--<b-form-input-->
      <!--id="input-name"-->
      <!--v-model="details.name"-->
      <!--required-->
      <!--&gt;</b-form-input>-->
      <!--</b-form-group>-->
      <!--</div>-->
      <!--<div class="col-12 col-sm-6">-->
      <!--<b-form-group-->
      <!--id="grp-email"-->
      <!--label="Email Address"-->
      <!--label-for="input-email"-->
      <!--label-class="cust-label mb-0 text-uppercase"-->
      <!--&gt;-->
      <!--<b-form-input-->
      <!--id="input-email"-->
      <!--type="email"-->
      <!--v-model="details.email"-->
      <!--required-->
      <!--&gt;</b-form-input>-->
      <!--</b-form-group>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="form-row m-0 w-100">-->
      <!--<div class="col-12 col-sm-6">-->
      <!--<b-form-group-->
      <!--id="grp-phone"-->
      <!--label="phone number (required for verification)"-->
      <!--label-for="input-phone"-->
      <!--label-class="cust-label mb-0 text-uppercase"-->
      <!--&gt;-->
      <!--<b-form-input-->
      <!--id="input-phone"-->
      <!--v-model="details.phone"-->
      <!--required-->
      <!--&gt;</b-form-input>-->
      <!--</b-form-group>-->
      <!--</div>-->
      <!--<div class="col-12 col-sm-6">-->
      <!--<b-form-group-->
      <!--id="grp-address"-->
      <!--label="Address"-->
      <!--label-for="input-address"-->
      <!--label-class="cust-label mb-0 text-uppercase">-->
      <!--<b-form-input-->
      <!--@click="removeReadOnly"-->
      <!--id="input-address"-->
      <!--ref="autocomplete"-->
      <!--placeholder=""-->
      <!--v-model="details.address"-->
      <!--autocomplete="off"-->
      <!--autocorrect="off"-->
      <!--autocapitalize="off"-->
      <!--readonly-->
      <!--required></b-form-input>-->
      <!--</b-form-group>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="form-row m-0 w-100">-->
      <!---->
      <!--&lt;!&ndash;<div class="col-12 col-sm-6">&ndash;&gt;-->
      <!--&lt;!&ndash;<b-form-group&ndash;&gt;-->
      <!--&lt;!&ndash;id="grp-cardType"&ndash;&gt;-->
      <!--&lt;!&ndash;label="Card TYPE"&ndash;&gt;-->
      <!--&lt;!&ndash;label-for="input-cardType"&ndash;&gt;-->
      <!--&lt;!&ndash;label-class="cust-label mb-0 text-uppercase"&ndash;&gt;-->
      <!--&lt;!&ndash;&gt;&ndash;&gt;-->
      <!--&lt;!&ndash;<b-form-select&ndash;&gt;-->
      <!--&lt;!&ndash;class="form-control"&ndash;&gt;-->
      <!--&lt;!&ndash;id="input-cardType"&ndash;&gt;-->
      <!--&lt;!&ndash;v-model="details.cardType"&ndash;&gt;-->
      <!--&lt;!&ndash;:options="cardTypeOptions"&ndash;&gt;-->
      <!--&lt;!&ndash;required&ndash;&gt;-->
      <!--&lt;!&ndash;&gt;</b-form-select>&ndash;&gt;-->
      <!--&lt;!&ndash;</b-form-group>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--<div class="col-12 col-sm-6">-->
      <!--<b-form-group-->
      <!--id="grp-cardNo"-->
      <!--label="Card Number"-->
      <!--label-for="input-cardNo"-->
      <!--label-class="cust-label mb-0 text-uppercase"-->
      <!--&gt;-->
      <!--<b-form-input-->
      <!--id="input-cardNo"-->
      <!--v-model="details.cardNo"-->
      <!--label-class="cust-label mb-0 text-uppercase"-->
      <!--required-->
      <!--&gt;</b-form-input>-->
      <!--</b-form-group>-->
      <!--</div>-->
      <!--<div class="col-12 col-sm-6">-->
      <!--<b-form-group-->
      <!--id="grp-cvv"-->
      <!--label="CVC / CVV2 (What is this?)"-->
      <!--label-for="input-cvv"-->
      <!--label-class="cust-label mb-0 text-uppercase"-->
      <!--&gt;-->
      <!--<b-form-input-->
      <!--id="input-cvv"-->
      <!--v-model="details.cvc"-->
      <!--required>-->
      <!--</b-form-input>-->
      <!--</b-form-group>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="form-row m-0 w-100">-->
      <!--<div class="col-6 col-sm-3">-->
      <!--<b-form-group-->
      <!--id="grp-cardExpiryMo"-->
      <!--label="Card expiry"-->
      <!--label-for="input-cardExpiryMo"-->
      <!--label-class="cust-label mb-0 text-uppercase"-->
      <!--&gt;-->
      <!--<b-form-select-->
      <!--class="form-control"-->
      <!--id="input-cardExpiryMo"-->
      <!--v-model="details.cardExpiry.month"-->
      <!--:options="cardMonthOptions"-->
      <!--required-->
      <!--&gt;</b-form-select>-->
      <!--</b-form-group>-->
      <!--</div>-->
      <!--<div class="col-6 col-sm-3">-->
      <!--<b-form-group-->
      <!--id="grp-cardExpiryYr"-->
      <!--label-for="input-cardExpiryYr"-->
      <!--&gt;-->
      <!--<div slot="label" style="opacity: 0">-->
      <!--Expiry-->
      <!--</div>-->
      <!--<b-form-select-->
      <!--class="form-control"-->
      <!--id="input-cardExpiryYr"-->
      <!--v-model="details.cardExpiry.year"-->
      <!--:options="years"-->
      <!--required-->
      <!--&gt;</b-form-select>-->
      <!--</b-form-group>-->
      <!--</div>-->
      <!---->
      <!--</div>-->
      <!--</b-form>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="py-5 px-3 text-center d-flex flex-column justify-content-center" v-if="active === 3">-->
      <!--<lottie-wrapper :options="defaultOptions" class="my-5" :width="200" :height="200"/>-->
      <!--&lt;!&ndash;<img height="200" src="../../assets/svg/success.svg" alt="" class="my-5">&ndash;&gt;-->
      <!--<p class="success-head display-4">Your tickets are on the way</p>-->
      <!--<h3 class="success-sub my-auto pb-3">Leicester Caribbean Carnival<br>-->
      <!--<span v-for="(tick, index) in selectedTickets" :key="`tick-${index}`">-->
      <!--{{tick.quantity}} x {{tick.title}} <br>-->
      <!--</span>-->
      <!---->
      <!--</h3>-->
      <!--<p class="">Confirmation email has been sent with further details to {{details.email}}</p>-->
      <!--</div>-->
      <!--&lt;!&ndash; end tickets section &ndash;&gt;-->
      <!---->
      <!--<div class="row px-3 py-5 d-none d-lg-block">-->
      <!--<div class="col-12">-->
      <!--<p class="mb-4 lh-6">-->
      <!--<small class="text-faint">-->
      <!--Once your purchase is completed a confirmation letter would be sent to you. <br>-->
      <!--Please print-->
      <!--your e-ticket to gain entry into the carnival.<br>-->
      <!--Tickets need to be redeemed at the ticket booth-->
      <!--</small>-->
      <!--</p>-->
      <!--<div class="" v-if="active !== 3">-->
      <!--<b-button class="btn-light mr-2" @click="prev" :disabled="active === 1">BACK</b-button>-->
      <!--<b-button @click="next" class="btn-next" :disabled="working">-->
      <!--{{active === 2 ? 'PURCHASE TICKETS' : 'NEXT'}}-->
      <!--<b-spinner style="width: 17px; height: 17px" v-if="working" class="ml-2"-->
      <!--small></b-spinner>-->
      <!--</b-button>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="col-lg-4 border-top border-right border-bottom bg-white">-->
      <!--<div class="row px-3 py-4">-->
      <!--<div class="col-12">-->
      <!--<h5 class="m-0 font-weight-bold">Leicester Carribean Carnival</h5>-->
      <!--<p class="mb-4 font-weight-bold f-14">Saturday 3rd August, 2019</p>-->
      <!--<div class="d-flex align-items-center justify-content-between text-gr"-->
      <!--v-for="(sTicket, index) in selectedTickets"-->
      <!--:key="`sTicket-${index}`">-->
      <!--<p class="m-0">{{sTicket.quantity}} x {{sTicket.title}}</p>-->
      <!--<p class="m-0">£{{sTicket.quantity * sTicket.price}}.00</p>-->
      <!--</div>-->
      <!--&lt;!&ndash;<div class="d-flex align-items-center justify-content-between text-gr">&ndash;&gt;-->
      <!--&lt;!&ndash;<p class="m-0">1 x Child Entry (5yrs - 13yrs)</p>&ndash;&gt;-->
      <!--&lt;!&ndash;<p class="m-0">£1.00</p>&ndash;&gt;-->
      <!--&lt;!&ndash;</div>&ndash;&gt;-->
      <!--<div class="d-flex align-items-center justify-content-between font-weight-bold">-->
      <!--<p class="m-0">Booking Fees</p>-->
      <!--<p class="m-0">£{{bookingFees}}</p>-->
      <!--</div>-->
      <!--<hr class="my-4">-->
      <!--<div class="d-flex align-items-center justify-content-between font-weight-bold mb-2">-->
      <!--<p class="mb-0">FINAL PRICE</p>-->
      <!--<p class="mb-0">£{{totalWithBooking}}</p>-->
      <!--</div>-->
      <!--<div>-->
      <!--<p class="text-gr f-15"><em>Total including all fees (No hidden extras)</em></p>-->
      <!--</div>-->
      <!--<div class="">-->
      <!--<img height="25px" src="../../assets/img/brands/pay-options-stack.png" alt="" class="">-->
      <!--</div>-->
      <!--<hr class="my-4">-->
      <!--<ul>-->
      <!--<li>Guaranteed original tickets</li>-->
      <!--<li>Receive your tickets on time</li>-->
      <!--<li>100% refund if the event is cancelled</li>-->
      <!--</ul>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="row px-3 py-5 d-lg-none">-->
      <!--<div class="col-12">-->
      <!--<p class="mb-4 lh-6">-->
      <!--<small class="text-faint">-->
      <!--Once your purchase is completed a confirmation letter would be sent to you. <br>-->
      <!--Please print-->
      <!--your e-ticket to gain entry into the carnival.<br>-->
      <!--Tickets need to be redeemed at the ticket booth-->
      <!--</small>-->
      <!--</p>-->
      <!--<div class="" v-if="active !== 3">-->
      <!--<b-button class="btn-light mr-2" @click="prev" :disabled="active === 1">BACK</b-button>-->
      <!--<b-button @click="next" class="btn-next" :disabled="working">-->
      <!--{{active === 2 ? 'PURCHASE TICKETS' : 'NEXT'}}-->
      <!--<b-spinner style="width: 17px; height: 17px" v-if="working" class="ml-2"-->
      <!--small></b-spinner>-->
      <!--</b-button>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!---->
      <!--<div class="row mt-100 mb-80">-->
      <!--<div class="col-12">-->
      <!--<p class="text-center f-14 text-faint disclosure"><span class="text-lilac">Please note free entry for those under 5 years and adults 60+. Some persons may be challenged and proof of age may be required.</span><br>Physical-->
      <!--tickets will also be available from Stabanas Cultural Products on Charles Street up until Friday 2nd August-->
      <!--only. <br>Ticket booths open at Victoria Park on Carnival Day at 9am. Tickets sold on Carnival Day will be-->
      <!--£4 for adults. Children tickets will remain at £1.<br>All tickets are to be taken to the advanced ticket-->
      <!--booth or windows to be exchanged for a wrist band to gain access to the grounds. No wrist band, no entry.-->
      <!--</p>-->
      <!--</div>-->
      <!--</div>-->
    </div>
  </section>
</template>
<script>
import { dbRefs } from "../../services/firebase/init";
import EventMixin from "../../mixins/eventInfo";
// import AppTicketInput from '../../components/AppTicketInput.vue';
import axios from "axios";
import gmapsInit from "../../utils/gmaps";
import addYears from "date-fns/add_years";
import successAnim from "../../assets/animations/1175-email.json";
import format from "date-fns/format";

export default {
  data() {
    return {
      createTokenURL:
        "https://us-central1-test-11fb9.cloudfunctions.net/createStripeToken",
      payURL: "https://us-central1-test-11fb9.cloudfunctions.net/paystripe",
      eventID: "103935",
      working: false,
      stripe: "",
      iconSize: "",
      ticketlistEvent: {},
      active: 1,
      content: {},
      images: {},
      selectedTickets: [],
      details: {
        name: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        cardNo: "",
        cardExpiry: {
          month: "",
          year: "",
        },
        cvc: "",
      },
      cardMonthOptions: [
        { value: "01", text: "01" },
        { value: "02", text: "02" },
        { value: "03", text: "03" },
        { value: "04", text: "04" },
        { value: "05", text: "05" },
        { value: "06", text: "06" },
        { value: "07", text: "07" },
        { value: "08", text: "08" },
        { value: "09", text: "09" },
        { value: "10", text: "10" },
        { value: "11", text: "11" },
        { value: "12", text: "12" },
      ],
      errors: {
        1: "Select minimum 1 ticket",
        2: "Please fill all fields",
      },
      autocomplete: null,
      defaultOptions: {
        animationData: successAnim,
        loop: false,
        renderer: "svg",
      },
    };
  },
  // components: {
  //   AppTicketInput
  // },
  mixins: [EventMixin],
  firestore: {
    content: dbRefs.ticketsRef,
    images: dbRefs.imgRef.doc("tickets"),
  },
  methods: {
    canProceed() {
      if (this.active >= 3) {
        return false;
      }
      if (this.active === 1) {
        return this.selectedTickets.length > 0;
      }
      return (
        Object.keys(this.details).filter((detail) => {
          if (detail !== "cardExpiry") {
            return this.details[detail].length < 1;
          }
          const { month, year } = this.details.cardExpiry;
          return month.length < 1 && year.length < 1;
        }).length < 1
      );
    },
    reportError() {
      if (this.active === 1) {
        this.$toasted.error(this.errors[this.active]);
        return;
      }
      this.$refs["detail-form"].reportValidity();
    },
    async next() {
      if (!this.canProceed()) {
        this.reportError();
        return false;
      }
      if (this.active === 2) {
        try {
          await this.pay();
        } catch (e) {
          console.log(e, "err");
          this.$toasted.error(
            e.response.data || "Something went wrong. Please try again"
          );
          return;
        }
      }
      this.active += 1;
      this.scrollToSection("scroll-down");
    },
    prev() {
      if (this.active > 1) {
        this.active -= 1;
        this.scrollToSection("scroll-down");
      }
    },
    async pay() {
      try {
        this.working = true;
        // const tokenReq = await this.createToken();
        // const { id: token } = tokenReq.data;
        await this.createOrder();
        // const orderReq = await this.createOrder(token);

        //          const { cardNo, cardExpiry, cvc, ...metadata } = this.details
        //          const body = {
        //            amount: this.totalWithBooking * 100,
        //            currency: 'gbp',
        //            description: `Payment for Leicester Caribbean tickets`,
        //            token,
        //            metadata
        //          }
        //          const payResp = await axios.post(this.payURL, body)
        //          const { status } = payResp.data
        //          if (status === 'succeeded') {
        //            const orderReq = await this.createOrder(payResp.data)
        //          } else {
        //            throw new Error('Something went wrong')
        //          }
      } catch (e) {
        throw e;
      } finally {
        this.working = false;
      }
    },
    async createToken() {
      try {
        let addrData;
        try {
          addrData = await this.formatAddress();
        } catch (e) {
          // pass
        }
        console.log(addrData);
        const {
          cardNo: number,
          cardExpiry: { month: exp_month, year: exp_year },
          cvc,
          address,
        } = this.details;
        const body = {
          number,
          exp_month,
          exp_year,
          cvc,
          address_line1: addrData
            ? `${addrData.streetNum.long_name}, ${
                addrData.streetName.long_name
              }`
            : address,
          address_line2: addrData ? `${addrData.locality.long_name}` : address,
          address_zip: addrData ? `${addrData.postalCode.long_name}` : address,
          address_country: addrData ? `${addrData.country.long_name}` : address,
        };
        const tokenObj = await axios.post(this.createTokenURL, body);
        return tokenObj;
      } catch (e) {
        throw e;
      }
    },
    async createOrder(token = "jndjndcjndcjcdj") {
      try {
        const [first_name, last_name] = this.details.name.split(" ");
        const body = {
          api_key: "wSsLHqhPffmxXNrcDcPV4JhW8fENTPgbwrbc7xZX",
          email: this.details.email,
          first_name: first_name || "",
          last_name: last_name || "",
          gender: "M",
          address: this.details.address,
          "address_data[city]": this.details.city,
          event_id: this.eventID,
          //            transaction_details: txDetails,
          token,
        };
        console.log(body, "body");
        for (let i = 0; i < this.selectedTickets.length; i++) {
          body[`tickets[${i}][ticket_id]`] = this.selectedTickets[i].ticket_id;
          body[`tickets[${i}][title]`] = this.selectedTickets[i].title;
          body[`tickets[${i}][price]`] = this.selectedTickets[i].price;
          body[`tickets[${i}][quantity]`] = this.selectedTickets[i].quantity;
          body[`tickets[${i}][vat]`] = 0;
          body[`tickets[${i}][fee]`] = 0.5;
          body[`tickets[${i}][metadata]`] = "";
        }

        let data = Object.keys(body)
          .map(function(key) {
            return (
              encodeURIComponent(key) + "=" + encodeURIComponent(body[key])
            );
          })
          .join("&");

        console.log(data, "cleaned data");
        // const response = await axios({
        //   withCredentials: false,
        //   crossdomain: true,
        //   url: 'https://ticketlist.co.uk/api/v3.1/orders/create?dev=1',
        //   method: 'POST',
        //   headers: {
        //     'Content-Type': 'application/x-www-form-urlencoded'
        //   },
        //   data
        // });
        // await dbRefs.errorRef.add({ mesg: response.data, status: 'ok', timestamp: format(new Date(), 'YYYY-MM-DD') });
      } catch (e) {
        // await dbRefs.errorRef.add({
        //   mesg: e.response || e,
        //   status: 'error',
        //   timestamp: format(new Date(), 'YYYY-MM-DD')
        // });
        throw e;
      }
    },
    async fetchEvent() {
      const reqData = {
        api_key: "wSsLHqhPffmxXNrcDcPV4JhW8fENTPgbwrbc7xZX",
        event_id: "103935",
      };

      let data = Object.keys(reqData)
        .map(function(key) {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(reqData[key])
          );
        })
        .join("&");

      try {
        const response = await axios({
          withCredentials: false,
          crossdomain: true,
          url: `https://ticketlist.co.uk/api/v3.1/events/get`,
          method: "POST",
          data,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });
        this.ticketlistEvent = response.data.response;
      } catch (e) {
        this.$toasted.error("There may be a network issue. Please refresh.");
      }
    },
    addRemoveTicket(evtValue, ticket) {
      const { ticket_id } = ticket;
      if (evtValue === 0) {
        return (this.selectedTickets = this.selectedTickets.filter(
          (s) => s.ticket_id !== ticket_id
        ));
      }
      const index = this.selectedTickets.findIndex(
        (s) => s.ticket_id === ticket_id
      );
      if (index !== -1) {
        const updatedTicket = this.selectedTickets[index];
        updatedTicket.quantity = evtValue;
        return this.selectedTickets.splice(index, 1, updatedTicket);
      }
      ticket["quantity"] = 1;
      this.selectedTickets.push(ticket);
    },
    numTickets(ticketID) {
      const index = this.selectedTickets.findIndex(
        (ticket) => ticket.ticket_id === ticketID
      );
      return index === -1 ? 0 : this.selectedTickets[index].quantity;
    },
    async initPlaces() {
      const google = await gmapsInit();
      this.autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("input-address")
      );
    },
    async formatAddress() {
      const google = await gmapsInit();
      const geocoder = new google.maps.Geocoder();
      try {
        geocoder.geocode(
          { address: this.details.address },
          (results, status) => {
            return new Promise((resolve, reject) => {
              if (status !== "OK" || !results[0]) {
                return reject(new Error("address not valid"));
              }
              const { address_components } = results[0];
              return resolve({
                streetNum: address_components.find(
                  (comp) => comp.types[0] === "street_number"
                ),
                streetName: address_components.find(
                  (comp) => comp.types[0] === "route"
                ),
                area: address_components.find((comp) =>
                  comp.types[0].includes("administrative_area_level_2")
                ),
                locality: address_components.find((comp) =>
                  comp.types[0].includes("locality")
                ),
                country: address_components.find((comp) =>
                  comp.types[0].includes("country")
                ),
                postalCode: address_components.find(
                  (comp) => comp.types[0] === "postal_code"
                ),
              });
            });
          }
        );
      } catch (e) {
        console.log(e, "err");
      }
    },
    removeReadOnly() {
      document.getElementById("input-address").removeAttribute("readonly");
    },
  },
  computed: {
    total() {
      if (this.selectedTickets.length > 0) {
        const fee = this.selectedTickets.reduce((accumulator, ticket) => {
          return accumulator + parseInt(ticket.price) * ticket.quantity;
        }, 0);
        return fee.toFixed(2);
      }
      return 0;
    },
    penceTotal() {
      return (this.total + this.bookingFees) * 100;
    },
    bookingFees() {
      const fee = this.selectedTickets.reduce((accumulator, ticket) => {
        return accumulator + 0.5 * ticket.quantity;
      }, 0);
      return fee.toFixed(2);
    },
    totalWithBooking() {
      const fee = parseFloat(this.total) + parseFloat(this.bookingFees);
      return fee.toFixed(2);
    },
    years() {
      const today = new Date();
      const years = [];
      for (let i = 0; i <= 10; i++) {
        const year = new Date(addYears(today, i)).getFullYear();
        years.push({ value: year, text: year });
      }
      return years;
    },
  },
  watch: {
    active: async function(newValue) {
      if (newValue === 2) {
        await this.initPlaces();
        this.autocomplete.addListener("place_changed", () => {
          let place = this.autocomplete.getPlace();
          this.details.address = place.formatted_address;
          this.details.city = place.address_components[1].short_name;
        });
      }
    },
  },
  async mounted() {
    let embedScript = document.createElement("script");
    embedScript.setAttribute("src", "https://ticketlist.co.uk/embed.js");
    document.head.appendChild(embedScript);
    // await this.fetchEvent();
  },
};
</script>

<style scoped lang="scss">
.icon-size {
  font-size: 1.8em;
}

.nav {
  li {
    a {
      color: #ff6a1d;
    }
  }
}

.step-text {
  letter-spacing: 2px;
  color: #000000;
  font-size: 13px;
  /*line-height: 1.35;*/
  font-weight: bold;
  @media (max-width: 568px) {
    letter-spacing: 0px;
    font-size: 10px;
    text-wrap: none;
  }
}

.text-event {
  letter-spacing: 3.4px;
}

input[class="tick-control"] {
  width: 100%;
  height: 28px;
  border: 0px;
  color: #ffffff;
  font-size: 18px;
  text-align: center;
  background: transparent;
  padding: 4px 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.input {
  float: left;
  width: 50px;
  height: 28px;
  padding: 0 11px;
  margin: 0 10px;
  position: relative;
  background: url("../../assets/img/ticket copy.png") no-repeat top left;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.btn-next {
  background-color: #93c43f;
}

.ticket-left {
  top: 13%;
}

.ticket-right {
  right: 0;
  top: 13%;
}

.img-ticket-flank-1 {
  width: 214px;
  height: 214px;
  /*background: url("../../assets/img/ticket-1.png");*/
  margin-right: 38px;
  @media (max-width: 576px) {
    margin: 25px auto;
  }
}

.img-ticket-flank-2 {
  width: 314px;
  height: 314px;
  /*background: url("../../assets/img/ticket-2.png");*/
  margin-right: 38px;
  @media (max-width: 576px) {
    margin: 25px auto;
  }
}

.img-ticket-flank-3 {
  width: 214px;
  height: 214px;
  /*background: url("../../assets/img/ticket-3.png");*/
  @media (max-width: 576px) {
    margin: 25px auto;
  }
}

.text-gr {
  color: #858585;
}

.text-faint {
  font-size: 14px;
  line-height: 1.29;
  color: #aeaeae;
}

.disclosure {
  line-height: 2.14;
}

.border {
  border: 1px solid #ebebeb !important;
}

.text-gray {
  color: #858585;
}

.heading {
  font-size: 17px;
  font-weight: 900;
  line-height: 1.38;
  letter-spacing: 3.4px;
  color: #000000;
}

.form-control {
  border: solid 1px #ebebeb;

  &::placeholder {
    font-size: 16px;
    line-height: 3.53;
    text-align: left;
    color: #d3d3d3;
  }
}

.success-head {
  font-size: 45px;
  letter-spacing: -1px;
  /*line-height: 2;*/
  /*text-align: center;*/
  /*color: #231f20;*/
}

.success-sub {
  font-size: 28px;
  /*font-weight: 300;*/
  /*line-height: 1.1;*/
  /*letter-spacing: -1px;*/
  /*color: #000000;*/
}

input[readonly] {
  cursor: text;
  background-color: #fff;
}
</style>
